import BaseClient from '@/app/model/api/response/baseApiClient'

class AreaDeleteApi extends BaseClient {
  public doAreaDelete (id: string) {
    const path: string = '/v1/master/areas/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new AreaDeleteApi()
